var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bg-secondary-1 py-2 px-2 board-radius" }, [
    _c(
      "div",
      { staticClass: "bg-white rounded p-2", attrs: { id: "providerInfoRef" } },
      [
        _c("div", { staticClass: "row p-2" }, [
          _c("div", { staticClass: "col-md-6 col-sm-12" }, [
            _c("div", { staticClass: "d-flex" }, [
              _c("em", {
                staticClass: "pt-1 mr-2 text-orange fas fa-address-book"
              }),
              _c("div", [
                _c("span", { staticClass: "font-12 color-gray-6" }, [
                  _vm._v("Nombre del Proveedor:")
                ]),
                _c("p", { staticClass: "font-14 color-black" }, [
                  _vm._v(_vm._s(_vm.model.companyName))
                ])
              ])
            ])
          ]),
          _c("div", { staticClass: "col-md-3 col-sm-12" }, [
            _c("div", { staticClass: "d-flex" }, [
              _c("em", {
                staticClass: "pt-1 mr-2 text-orange fas fa-address-book"
              }),
              _c("div", [
                _c("span", { staticClass: "font-12 color-gray-6" }, [
                  _vm._v("Tipo de Proveedor:")
                ]),
                _c("p", { staticClass: "font-14 color-black" }, [
                  _vm._v(_vm._s(_vm.model.companyTypeName))
                ])
              ])
            ])
          ]),
          _c("div", { staticClass: "col-md-2 col-sm-12" }, [
            _c("div", { staticClass: "d-flex" }, [
              _c("em", {
                staticClass: "pt-1 mr-2 text-orange fas fa-address-book"
              }),
              _c(
                "div",
                [
                  _c("span", { staticClass: "font-12 color-gray-6" }, [
                    _vm._v("SSN Patronal:")
                  ]),
                  !_vm.editMode
                    ? [
                        _c("p", { staticClass: "font-14 color-black" }, [
                          _vm._v(_vm._s(_vm.model.ssn))
                        ])
                      ]
                    : [
                        _c("ValidationObserver", {
                          ref: "providerInfoRef",
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function({ validate }) {
                                return [
                                  _c("ValidationProvider", {
                                    attrs: { name: "ssn", rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function({
                                            errors,
                                            failedRules
                                          }) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex align-items-center"
                                                },
                                                [
                                                  _c("CustomInput", {
                                                    attrs: {
                                                      "custom-error-msg": "",
                                                      error: errors[0],
                                                      "mask-type":
                                                        "SSNPatronal",
                                                      placeholder:
                                                        "Escriba SSN Patronal",
                                                      type: "text"
                                                    },
                                                    model: {
                                                      value: _vm.model.ssn,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.model,
                                                          "ssn",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "model.ssn"
                                                    }
                                                  }),
                                                  _c("ActionButton", {
                                                    staticClass:
                                                      "btn-action-size ml-2",
                                                    attrs: {
                                                      i: "fas fa-save",
                                                      variant: "outline-success"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.submitForm(
                                                          validate
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _c("ActionButton", {
                                                    staticClass:
                                                      "btn-action-size ml-2",
                                                    attrs: {
                                                      i: "fas fa-ban",
                                                      variant: "outline-danger"
                                                    },
                                                    on: {
                                                      click: _vm.cancelEdit
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              failedRules.required
                                                ? _c("Error", {
                                                    attrs: {
                                                      message:
                                                        "El SSN es requerido.",
                                                      variant: "no-border"
                                                    }
                                                  })
                                                : _vm._e()
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                ]
                              }
                            }
                          ])
                        })
                      ]
                ],
                2
              )
            ])
          ]),
          _c(
            "div",
            { staticClass: "col-md-1 col-sm-12" },
            [
              _vm.canEditSsn && !_vm.editMode
                ? _c("ActionButton", {
                    staticClass: "btn-action-size",
                    attrs: { i: "fas fa-edit", variant: "outline-success" },
                    on: {
                      click: function($event) {
                        _vm.editMode = true
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }